import App from "@modules/app/components/App";
import AppHeader from "@modules/app/components/AppHeader";
import AppContent from "@modules/app/components/AppContent";
import AppFooter from "@modules/app/components/AppFooter";
import AccordionWrapper from "./components/AccordionWrapper.vue";
import ContentPopup from "./components/ContentPopup";
import ContentSwitcherButton from "./components/ContentSwitcherButton";
import ComboBox from "./components/ComboBox";
import DatePicker from "./components/DatePicker";
import DonutChart from "./components/DonutChart";
import DropdownComponent from "./components/DropdownComponent.vue";
import EllipsisText from "./components/EllipsisText";
import FilterTagButton from "./components/FilterTagButton";
import InputRadio from "./components/InputRadio";
import InputCheckbox from "./components/InputCheckbox";
import IconLink from "./components/IconLink";
import LinkButton from "./components/LinkButton";
import LabelButton from "./components/LabelButton";
import TooltipButton from "./components/TooltipButton";
import UserAvatar from "@plugins/common/components/UserAvatar";
import AnnotatableRichText from "@modules/annotation/components/AnnotatableRichText";
import UserList from "@plugins/common/components/UserList";
import AttachedToolbarContainer from "@plugins/common/components/AttachedToolbarContainer";
import AttachedToolbar from "@plugins/common/components/AttachedToolbar";
import AttachmentPlaceholder from "@plugins/common/components/AttachmentPlaceholder";
import TextInput from "@plugins/common/components/TextInput";
import EditableTagList from "@plugins/common/components/EditableTagList";
import TextArea from "@plugins/common/components/TextArea";
import FetchDataButton from "@plugins/common/components/FetchDataButton";
import MessageComponent from "@plugins/common/components/MessageComponent";
import MultiSelect from "@plugins/common/components/MultiSelect";
import SvgIcon from "@plugins/common/components/SvgIcon";
import SearchBar from "@plugins/common/components/SearchBar";
import ListComponent from "@plugins/common/components/ListComponent";
import OverflowMenu from "./components/OverflowMenu.vue";
import OverflowMenuButton from "@plugins/common/components/OverflowMenuButton";
import OverflowMenuItem from "./components/OverflowMenuItem.vue";
import PageTemplate from "@plugins/common/components/PageTemplate";
import FilterSelection from "@plugins/common/components/FilterSelection";
import ButtonPicker from "@plugins/common/components/ButtonPicker";
import StackedColumnBar from "@plugins/common/components/StackedColumnBar";
import SelectionBar from "@plugins/common/components/SelectionBar";
import SelectionBarMenu from "@plugins/common/components/SelectionBarMenu";
import SelectionBarMenuItem from "@plugins/common/components/SelectionBarMenuItem";
import LabelComponent from "@plugins/common/components/LabelComponent";
import IconLabelComponent from "@plugins/common/components/IconLabelComponent";
import OverlayLoader from "@plugins/common/components/OverlayLoader";
import StructuredListWrapper from "@plugins/common/components/StructuredListWrapper";
import InlineLoader from "@plugins/common/components/InlineLoader";
import EmptyPlaceholder from "@plugins/common/components/EmptyPlaceholder";
import StarResourceButton from "@plugins/common/components/StarResourceButton";
import MatchIndicator from "@plugins/common/components/MatchIndicator.vue";
import ButtonWrapper from "./components/ButtonWrapper.vue";
import DataTable from "@plugins/vuetify/components/DataTable.vue";

const commonPlugin = {
  install(app) {
    app.component("App", App);
    app.component("AppHeader", AppHeader);
    app.component("AppContent", AppContent);
    app.component("AppFooter", AppFooter);
    app.component("AccordionWrapper", AccordionWrapper);
    app.component("ContentPopup", ContentPopup);
    app.component("ContentSwitcherButton", ContentSwitcherButton);
    app.component("ComboBox", ComboBox);
    app.component("DataTable", DataTable);
    app.component("DatePicker", DatePicker);
    app.component("DonutChart", DonutChart);
    app.component("DropdownComponent", DropdownComponent);
    app.component("EllipsisText", EllipsisText);
    app.component("FilterTagButton", FilterTagButton);
    app.component("InputRadio", InputRadio);
    app.component("InputCheckbox", InputCheckbox);
    app.component("IconLink", IconLink);
    app.component("LinkButton", LinkButton);
    app.component("LabelButton", LabelButton);
    app.component("TooltipButton", TooltipButton);
    app.component("UserAvatar", UserAvatar);
    app.component("AnnotatableRichText", AnnotatableRichText);
    app.component("UserList", UserList);
    app.component("AttachedToolbarContainer", AttachedToolbarContainer);
    app.component("AttachedToolbar", AttachedToolbar);
    app.component("AttachmentPlaceholder", AttachmentPlaceholder);
    app.component("TextInput", TextInput);
    app.component("TextArea", TextArea);
    app.component("FetchDataButton", FetchDataButton);
    app.component("MessageComponent", MessageComponent);
    app.component("MultiSelect", MultiSelect);
    app.component("SvgIcon", SvgIcon);
    app.component("SearchBar", SearchBar);
    app.component("ListComponent", ListComponent);
    app.component("OverflowMenu", OverflowMenu);
    app.component("OverflowMenuButton", OverflowMenuButton);
    app.component("OverflowMenuItem", OverflowMenuItem);
    app.component("PageTemplate", PageTemplate);
    app.component("FilterSelection", FilterSelection);
    app.component("ButtonPicker", ButtonPicker);
    app.component("StackedColumnBar", StackedColumnBar);
    app.component("SelectionBar", SelectionBar);
    app.component("SelectionBarMenu", SelectionBarMenu);
    app.component("SelectionBarMenuItem", SelectionBarMenuItem);
    app.component("LabelComponent", LabelComponent);
    app.component("IconLabelComponent", IconLabelComponent);
    app.component("OverlayLoader", OverlayLoader);
    app.component("StructuredListWrapper", StructuredListWrapper);
    app.component("InlineLoader", InlineLoader);
    app.component("EmptyPlaceholder", EmptyPlaceholder);
    app.component("StarResourceButton", StarResourceButton);
    app.component("EditableTagList", EditableTagList);
    app.component("MatchIndicator", MatchIndicator);
    app.component("button-wrapper", ButtonWrapper);
  },
};

export default commonPlugin;
